import { render, staticRenderFns } from "./InfoBox.vue?vue&type=template&id=9a4e4a00&scoped=true"
import script from "./InfoBox.vue?vue&type=script&lang=ts"
export * from "./InfoBox.vue?vue&type=script&lang=ts"
import style0 from "./InfoBox.vue?vue&type=style&index=0&id=9a4e4a00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4e4a00",
  null
  
)

export default component.exports